export default {
  JM: '^[0-9]{2}$',
  AD: '^AD[0-9]{3}$',
  AF: '^[0-9]{4}$',
  AI: '^AI2640$',
  AL: '^[0-9]{4}$',
  AM: '^[0-9]{4}$',
  AQ: '^BIQQ1ZZ$',
  AR: '^[0-9]{4}$',
  AS: '^[0-9]{5}$',
  AT: '^[0-9]{4}$',
  AU: '^[0-9]{4}$',
  AX: '^(AX)?[0-9]{4}$',
  AZ: '^AZ[0-9]{4}$',
  BA: '^[0-9]{5}$',
  BB: '^(BB)?[0-9]{5}$',
  BD: '^[0-9]{4}$',
  BE: '^[0-9]{4}$',
  BG: '^[0-9]{4}$',
  BH: '^[0-9]{3,4}$',
  BL: '^97133$',
  BN: '^[a-zA-Z]{2}[0-9]{4}$',
  BO: '^[0-9]{4}$',
  BR: '^[0-9]{5}[\\-]?[0-9]{3}',
  BT: '^[0-9]{5}$',
  BY: '^[0-9]{6}$',
  CA: '^[A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]$',
  CC: '^[0-9]{4}$',
  CH: '^[0-9]{4}$',
  CL: '^[0-9]{7}$',
  CN: '^[0-9]{6}$',
  CO: '^[0-9]{6}$',
  CR: '^[0-9]{5}$',
  CU: '^[0-9]{5}$',
  CV: '^[0-9]{4}$',
  CX: '^[0-9]{4}$',
  CY: '^[0-9]{4}$',
  CZ: '^[0-9]{5}$',
  DE: '^[0-9]{5}$',
  DK: '^[0-9]{3,4}$',
  DO: '^[0-9]{5}$',
  DZ: '^[0-9]{5}$',
  EC: '^[0-9]{6}$',
  EE: '^[0-9]{5}$',
  EG: '^[0-9]{5}$',
  ES: '^((0[1-9]|5[0-2])|[1-4][0-9])[0-9]{3}$',
  ET: '^[0-9]{4}$',
  FI: '^[0-9]{5}$',
  FK: '^FIQQ1ZZ$',
  FM: '^[0-9]{5}([0-9]{4})?$',
  FO: '^[0-9]{3}$',
  FR: '^[0-9]{5}$',
  GB: '^[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}$',
  GE: '^[0-9]{4}$',
  GF: '^973[0-9]{2}$',
  GG: '^[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}$',
  GI: '^GX111AA$',
  GL: '^[0-9]{4}$',
  GN: '^[0-9]{3}$',
  GP: '^971[0-9]{2}$',
  GR: '^[0-9]{5}$',
  GS: '^SIQQ1ZZ$',
  GT: '^[0-9]{5}$',
  GU: '^[0-9]{5}([0-9]{4})?$',
  GW: '^[0-9]{4}$',
  HM: '^[0-9]{4}$',
  HN: '^(HN)?[0-9]{5}$',
  HR: '^[0-9]{5}$',
  HT: '^[0-9]{4}$',
  HU: '^[0-9]{4}$',
  ID: '^[0-9]{5}$',
  IL: '^[0-9]{7}$',
  IM: '^[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}$',
  IN: '^[0-9]{6}$',
  IO: '^BBND1ZZ$',
  IQ: '^[0-9]{5}$',
  IR: '^[0-9]{10}$',
  IS: '^[0-9]{3}$',
  IT: '^[0-9]{5}$',
  JE: '^[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}$',
  JO: '^[0-9]{5}$',
  JP: '^\\d{3}-\\d{4}$',
  KE: '^[0-9]{5}$',
  KG: '^[0-9]{6}$',
  KH: '^[0-9]{5}$',
  KR: '^[0-9]{5}$',
  KW: '^[0-9]{5}$',
  KY: '^KY[0-9]{5}$',
  KZ: '^[0-9]{6}$',
  LA: '^[0-9]{5}$',
  LB: '^[0-9]{4}(?:[0-9]{4})?$',
  LC: '^LC[0-9]{5}$',
  LI: '^[0-9]{4}$',
  LK: '^[0-9]{5}$',
  LR: '^[0-9]{4}$',
  LS: '^[0-9]{3}$',
  LT: '^(LT)?[0-9]{5}$',
  LU: '^(L\\s*-\\s*)?[\\d]{4}$',
  LV: '^(LV)?[0-9]{4}$',
  LY: '^[0-9]{5}$',
  MA: '^[0-9]{5}$',
  MC: '^[0-9]{5}$',
  MD: '^(MD)?[0-9]{4}$',
  ME: '^[0-9]{5}$',
  MF: '^97150$',
  MG: '^[0-9]{3}$',
  MH: '^[0-9]{5}([0-9]{4})?$',
  MK: '^[0-9]{4}$',
  MM: '^[0-9]{5}$',
  MN: '^[0-9]{5}$',
  MP: '^[0-9]{5}([0-9]{4})?$',
  MQ: '^[0-9]{5}$',
  MS: '^(MSR)?[0-9]{4}$',
  MT: '^[A-Z]{3}[0-9]{4}$',
  MU: '^[0-9]{5}$',
  MV: '^[0-9]{5}$',
  MX: '^[0-9]{5}$',
  MY: '^[0-9]{5}$',
  MZ: '^[0-9]{4}$',
  NA: '^[0-9]{5}$',
  NC: '^988[0-9]{2}$',
  NE: '^[0-9]{4}$',
  NF: '^[0-9]{4}$',
  NG: '^[0-9]{6}$',
  NI: '^[0-9]{5}$',
  NL: '^[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}',
  NO: '^[0-9]{4}$',
  NP: '^[0-9]{5}$',
  NZ: '^[0-9]{4}$',
  OM: '^[0-9]{3}$',
  PA: '^[0-9]{6}$',
  PE: '^[0-9]{5}$',
  PF: '^987[0-9]{2}$',
  PG: '^[0-9]{3}$',
  PH: '^[0-9]{4}$',
  PK: '^[0-9]{5}$',
  PL: '^[0-9]{2}-[0-9]{3}$',
  PM: '^97500$',
  PN: '^PCRN1ZZ$',
  PR: '^[0-9]{5}([0-9]{4})?$',
  PS: '^[0-9]{3}$',
  PT: '^([0-9]{4}-[0-9]{3})$',
  PW: '^[0-9]{5}([0-9]{4})?$',
  PY: '^[0-9]{4}$',
  RE: '^974[0-9]{2}$',
  RO: '^[0-9]{6}$',
  RS: '^[0-9]{5}$',
  RU: '^[0-9]{3}([0-9]{3})?$',
  SA: '^[0-9]{5}([0-9]{4})?$',
  SD: '^[0-9]{5}$',
  SE: '^\\d{3}\\s?\\d{2}$',
  SG: '^[0-9]{6}$',
  SH: '^STHL1ZZ$',
  SI: '^[0-9]{4}$',
  SJ: '^[0-9]{4}$',
  SK: '^[0-9]{5}$',
  SM: '^4789[0-9]{1}$',
  SN: '^[0-9]{5}$',
  SO: '^[a-zA-Z]{2}[0-9]{5}$',
  SV: '^[0-9]{4}$',
  SZ: '^[a-zA-Z]{1}[0-9]{3}$',
  TC: '^TKCA1ZZ$',
  TD: '^[0-9]{5}$',
  TH: '^[0-9]{5}$',
  TJ: '^[0-9]{6}$',
  TM: '^[0-9]{6}$',
  TN: '^[0-9]{4}$',
  TR: '^[0-9]{5}$',
  TT: '^[0-9]{6}$',
  TW: '^[0-9]{5}$',
  TZ: '^[0-9]{5}$',
  UA: '^[0-9]{5}$',
  US: '^[0-9]{5}([0-9]{4})?$',
  UY: '^[0-9]{5}$',
  UZ: '^[0-9]{6}$',
  VA: '^00120$',
  VC: '^(VC)?[0-9]{4}$',
  VE: '^[0-9]{4}[a-zA-Z]?$',
  VG: '^(VG)?[0-9]{4}$',
  VI: '^[0-9]{5}([0-9]{4})?$',
  VN: '^[0-9]{6}$',
  WF: '^986[0-9]{2}$',
  WS: '^(WS)?[0-9]{4}$',
  XK: '^[0-9]{5}$',
  YT: '^[0-9]{5}$',
  ZA: '^[0-9]{4}$',
  ZM: '^[0-9]{5}'
};
